import dayjs from "dayjs";
import { renderToString } from "react-dom/server";

import { dayAndShortMonth } from "@similarweb/pro-logic-components";

import combineConfigs from "pro-features/components/Chart/src/combineConfigs";
import dailyIntervalConfig from "pro-features/components/Chart/src/configs/granularity/dailyIntervalConfig";
import noLegendConfig from "pro-features/components/Chart/src/configs/legend/noLegendConfig";
import tooltipContainerConfig from "pro-features/components/Chart/src/configs/tooltip/tooltipContainerConfig";
import xAxisCrosshair from "pro-features/components/Chart/src/configs/xAxis/xAxisCrosshair";
import yAxisLabelsConfig from "pro-features/components/Chart/src/configs/yAxis/yAxisLabelsConfig";
import bothAxisZoomConfig from "pro-features/components/Chart/src/configs/zoom/bothAxisZoomConfig";
import { percentageSignFilter } from "app/filters/ngFilters";
import { InfluenceGraphTooltip } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/sources-report/domain-influence/influence-over-time-graph/InfluenceGraphTooltip";
import type { SeriesLineItem } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/sources-report/domain-influence/influence-over-time-graph/types";

export const getGraphConfig = (data: Array<SeriesLineItem>) => {
    const yAxisFormatter = ({ value }) => percentageSignFilter()(value, 0);
    return combineConfigs({ yAxisFormatter }, [
        dailyIntervalConfig,
        noLegendConfig,
        yAxisLabelsConfig,
        xAxisCrosshair,
        tooltipContainerConfig,
        bothAxisZoomConfig,
        {
            chart: {
                height: 300,
                marginRight: 16,
            },
            plotOptions: {
                line: {
                    connectNulls: true,
                },
                series: {
                    connectNulls: true,
                },
            },
            xAxis: {
                minPadding: 0,
                maxPadding: 0,
                labels: {
                    formatter: function () {
                        return dayjs.utc(this.value).format(dayAndShortMonth);
                    },
                },
            },
            tooltip: {
                outside: true,
                useHTML: true,
                formatter() {
                    return renderToString(
                        <InfluenceGraphTooltip
                            context={this}
                            data={data}
                        />,
                    );
                },
            },
        },
    ]);
};
